import types from '../mutation-types';
import AdditionalAttributesAPI from '../../api/additionalAttributes';

export const state = {
  companyNames: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getCompanyNames: _state => {
    return _state.companyNames.map(name => ({ id: name, name }));
  },
  getUIFlags: _state => {
    return _state.uiFlags;
  },
};

export const actions = {
  getCompanyNames: async function getCompanyNames({ commit }) {
    commit(types.SET_ADDITIONAL_ATTRIBUTES_UI_FLAG, { isFetching: true });
    try {
      const response = await AdditionalAttributesAPI.getCompanyNames();
      commit(types.SET_COMPANY_NAMES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_ADDITIONAL_ATTRIBUTES_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_ADDITIONAL_ATTRIBUTES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_COMPANY_NAMES](_state, data) {
    _state.companyNames = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
